import type { WamFile } from "@workadventure/map-editor";
import { CreateTileLayerCommand } from "@workadventure/map-editor";
import type { GameMapFrontWrapper } from "../../../GameMap/GameMapFrontWrapper";
import type { FrontCommandInterface } from "../FrontCommandInterface";
import type { RoomConnection } from "../../../../../Connection/RoomConnection";
import { DeleteTileLayerFrontCommand } from "./DeleteTileLayerFrontCommand";

export class CreateTileLayerFrontCommand extends CreateTileLayerCommand implements FrontCommandInterface {
    constructor(
        wamFile: WamFile,
        layerId: number,
        name: string,
        index: number,
        opacity: number,
        visible: boolean,
        commandId: string | undefined,
        private gameMapFrontWrapper: GameMapFrontWrapper,
    ) {
        super(wamFile, layerId, name, index, opacity, visible, commandId);
    }

    public async execute(): Promise<void> {
        await super.execute();
        this.gameMapFrontWrapper.createTileLayer({
            layerId: this.layerId,
            name: this.name,
            index: this.index,
            opacity: this.opacity,
            visible: this.visible,
        });
    }

    public getUndoCommand(): DeleteTileLayerFrontCommand {
        return new DeleteTileLayerFrontCommand(this.wamFile, this.layerId, undefined, this.gameMapFrontWrapper);
    }

    public emitEvent(roomConnection: RoomConnection): void {
        roomConnection.emitMapEditorCreateTileLayer(this.commandId, {
            layerId: this.layerId,
            name: this.name,
            index: this.index,
            opacity: this.opacity,
            visible: this.visible,
        });
    }
}
